module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 57 50\"><path d=\"M40.3 0c-4.5 0-8.5 1.9-11.7 5-3.1-3.1-7.1-5-11.7-5C7.6 0 0 7.3 0 16.6c0 5.4 1.7 9.2 5.5 13.9l.2.3.3.2 19.3 16.3 3.1 2.6 3.1-2.6L50.8 31l.3-.2.2-.3c4.1-4.7 5.5-8.5 5.5-13.9C57.3 7.3 49.7 0 40.3 0m0 4.7c6.7 0 12 5.2 12 11.6 0 3.8-.7 6.7-4.3 10.7L28.6 43.3 9.3 27C5.7 23 5 20.1 5 16.3 5 9.7 10.3 4.7 16.9 4.7c6 0 11 4.5 11.7 10.2 1-5.7 5.8-10.2 11.7-10.2\" fill=\"#CCC\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./components/CharityImage/charity-default.svg
// module id = 865
// module chunks = 0